import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const FeeDefinitionDirectDebitOptionsSchema = z.object({
    // Empty for now, will be implemented in the future
});

export class FeeDefinitionDirectDebitOptions extends FromSchema(FeeDefinitionDirectDebitOptionsSchema) {
    // Empty for now, will be implemented in the future
}
